import baseRoute from '../baseRoute';

export default `${baseRoute}/notify` as const;
